module.exports = __webpack_public_path__ + "static/media/SG_Payslip_5.69482028.png";